export default __webpack_public_path__ + "static/media/make_confident_decisions.b41df0c7.png";